<div class="CopyLink">
    <div style="display:flex; flex-direction: row-reverse; margin: 6px;">
        <img (click)="uService.closeDialoge()" style="width: 12px; height: 12px; cursor: pointer;" src="../../../../../assets/media/icons/close_black.png" />
    </div>
    <div>
        <div class="text-center fs-6 text-muted fw-bold mb-5">
            Please Copy Text Below
        </div>
        <div class="fs-6 text-dark text-center fw-bold my-5">{{data.text || 'NA'}}</div>
    </div>
</div>